import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import { DialogHeader } from "../../auth/components/PasswordRecoveryModal";
import { useContext, useState } from "react";
import { MainContext } from "../context/MainContextProvider";

export function ConfirmationModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  setOpenSuccessModal?: (open: boolean) => void;
  setOpenErrorModal?: (open: boolean) => void;
  onConfirm: () => Promise<void>;
  title: string;
  contentText: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  confirmationButtonColor?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
    setApiErrorMessage?: (message?: string) => void;
}) {
  const { theme } = useContext(MainContext);
  const primary = theme.muiTheme.palette.primary.main;
  const { open, setOpen } = props;
  const [isLoading, setIsloading] = useState(false);
  const onClose = () => setOpen(false);
  const onConfirm = async () => {
    setIsloading(true);
    try {
      await props.onConfirm();
      setOpen(false);
      props.setOpenSuccessModal && props.setOpenSuccessModal(true);
    } catch(err: any) {
      props.setApiErrorMessage && props.setApiErrorMessage(String(err.message))
      props.setOpenErrorModal && props.setOpenErrorModal(true);
    }
    setIsloading(false);
  };
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        {props.title}
      </DialogHeader>
      <DialogContent
        sx={{
          width: "450px",
          height: "120px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        dividers
      >
        <Typography gutterBottom sx={{ fontSize: "18px" }}>
          {props.contentText}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          {props.cancelButtonText ?? "Cancelar"}
        </Button>
        <Button
          disabled={isLoading}
          sx={{
            backGroundColor: primary,
            borderColor: primary,
            height: "34px",
            width: "95px",
            "& .MuiTypography-root": {
              color: primary,
            },
            "&:hover": {
              borderColor: primary,
              backgroundColor: primary,
              color: primary,
              "& .MuiTypography-root": {
                color: "#FFFFFF",
              },
            },
          }}
          variant="contained"
          color={"primary"}
          onClick={onConfirm}
        >
          {props.confirmButtonText ?? "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
